module.exports = __webpack_public_path__ + "img/Wp_2081.c22bef3e.png";